import defaultApi from '@/utils/request';

export default {
  // ============================== S45W2001 ==================================
  // S45W2001 弱勢學生助學計畫申請作業
  // 判斷是否符合申請資格
  S45W2001_CheckData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2001_CheckData',
      params,
    });
  },
  // 取得弱勢學生助學計畫申請作業資料
  S45W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2001_Load',
      params,
    });
  },
  // 寫入弱勢學生助學計畫申請作業資料
  S45W2001_ViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2001_ViewAction',
      data,
    });
  },
  // 取得新增資料_選擇申請類別資料
  S45W2001_KindViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2001_KindViewLoad',
      params,
    });
  },
  // 新增資料_選擇申請類別頁面 存入申請檔
  S45W2001_KindViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2001_KindViewAction',
      data,
    });
  },
  // 取得關係人資料
  S45W2001_RelationViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2001_RelationViewLoad',
      params,
    });
  },
  // 關係人資料頁面 關係人資料
  S45W2001_RelationViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2001_RelationViewAction',
      data,
    });
  },

  // 加載列表 // S45W2002 學習單登錄作業
  S45W2002_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2002_LoadList',
      params,
    });
  },
  S45W2002_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2002_EditViewLoad',
      params,
    });
  },
  S45W2002_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2002_EditViewAction',
      data,
    });
  },
  S45W2002_Delete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2002_Delete',
      data,
    });
  },
  S45W2002_Send(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2002_Send',
      data,
    });
  },
  S45W2002_LoadDtlList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2002_LoadDtlList',
      params,
    });
  },
  S45W2002_DeleteDtl(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2002_DeleteDtl',
      data,
    });
  },
  S45W2002_EditDtlViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2002_EditDtlViewLoad',
      params,
    });
  },
  S45W2002_EditDtlViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2002_EditDtlViewAction',
      data,
    });
  },
  S45W2002_LeaveAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S45/S45W2002_LeaveAttachmentViewLoad',
      params,
    });
  },
  S45W2002_LeaveAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2002_LeaveAttachmentViewFileUpload',
      data,
    });
  },
  S45W2002_LeaveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S45/S45W2002_LeaveAttachmentViewFileDelete',
      data,
    });
  },
};
